'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'QuizSlide',
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    totalSlides: {
      type: Number,
      required: true
    },
    isFinalSlide: {
      type: Boolean,
      required: true
    }
  },

  data: function data() {
    return {
      answeredQuestions: [],
      loading: false
    };
  },


  computed: Object.assign({}, (0, _vuex.mapGetters)(['answersFor', 'finalAnswer', 'activeSlideIndex']), {
    compClass: function compClass() {
      return 'class' in this.$vnode.data ? '' : 'default-class';
    },
    layoutClass: function layoutClass() {
      var modifier = this.question.layout.split('').map(function (char, index) {
        return index === 0 ? char.toUpperCase() : char;
      }).join('');

      return 'qz-Slide_Body-layout' + modifier;
    },
    maxAnswersReached: function maxAnswersReached() {
      return this.answersFor(this.index).length >= this.question.maxAnswers;
    }
  }),

  methods: Object.assign({}, (0, _vuex.mapActions)(['finishQuiz']), (0, _vuex.mapMutations)(['removeFirstAnswer', 'setAnswer', 'setActiveSlideIndex']), {
    answerQuestion: function answerQuestion(_ref) {
      var index = _ref.index,
          answer = _ref.answer;

      var currentAmountAnswered = this.answersFor(index).length;

      if (currentAmountAnswered === this.question.maxAnswers && this.answersFor(index).includes(answer) === false) {
        this.removeFirstAnswer({ index: index, answer: answer });
      }

      this.setAnswer({ index: index, answer: answer });

      var currentAnswers = this.answersFor(index);

      if (currentAnswers.length > this.question.maxAnswers) {
        this.removeFirstAnswer({ index: index, answer: answer });
        var nowCurrentAnswers = this.answersFor(index);

        this.$refs.input.forEach(function (input) {
          return input.checked = nowCurrentAnswers.includes(input.value);
        });
      }
    },
    handleNextClick: function handleNextClick() {
      var _this = this;

      this.setActiveSlideIndex(this.activeSlideIndex + 1);

      this.answersFor(this.index).forEach(function (answer) {
        ga('send', 'event', 'Quiz', 'Question ' + (_this.index + 1), '' + answer.label);
      });
    },
    handlePrevClick: function handlePrevClick() {
      this.setActiveSlideIndex(this.activeSlideIndex - 1);
    },
    handleFinishClick: function handleFinishClick() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;

                _context.next = 3;
                return _this2.finishQuiz();

              case 3:

                _this2.answersFor(_this2.index).forEach(function (answer) {
                  ga('send', 'event', 'Quiz', 'Question ' + (_this2.index + 1), '' + answer.label);
                });

                window.location.href = '/pages/youre-a-' + _this2.finalAnswer;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//